import { fetchLiveTables } from '../../../model/liveTable';
import { LogicContext } from '../types';
import config from '../../../config';

export const fetchTableForPageGames = async (context: LogicContext) => {
  const { currentTablesIdList } = context;
  if (!currentTablesIdList || !currentTablesIdList.length) {
    return {
      liveDealerTables: {},
    };
  }
  const tables = await fetchLiveTables(
    currentTablesIdList,
    context.user?.currency || config.default_currency
  );

  return {
    liveDealerTables: tables,
  };
};
